module.exports = __webpack_public_path__ + "static/media/header.39032b70.png";